
function updateBeforeAfterContainer(container) {
  const input = container.querySelector('input[type="range"]');
  const handle = container.querySelector('.ims-slider .ims-handle-line');
  const afterImage = container.querySelector('.ims-image-after');

  if (!input || !handle || !afterImage) return;

  const slideValue = input.value;
  afterImage.style.clipPath =
    'polygon(0 0,' + slideValue + '% 0,' + slideValue + '% 100%, 0 100%)';
  handle.style.left = slideValue + '%';
}

// Delegated at the document level (not attached per-input) so this keeps working
// no matter how the containers reached the DOM — including owlCarousel's loop:true
// clones, which duplicate markup via cloneNode() without carrying over listeners
// that were bound directly to the original elements.
document.addEventListener('input', function (event) {
  if (!event.target.matches('.ims-container input[type="range"]')) return;
  updateBeforeAfterContainer(event.target.closest('.ims-container'));
});

function initBeforeAfterContainers() {
  document.querySelectorAll('.ims-container').forEach(updateBeforeAfterContainer);
}

initBeforeAfterContainers();

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initBeforeAfterContainers);
}
